import { riskAssessmentToken } from '@/utils/riskAssessmentToken';
import type { DangerSignFinding } from '../types';

export type DangerSignUrgency = 'urgent' | 'immediate';

export function urgencyOf(sign: DangerSignFinding): DangerSignUrgency {
  return sign.triage_recommendation === 'immediate' ? 'immediate' : 'urgent';
}

export function highestUrgency(signs: readonly DangerSignFinding[]): DangerSignUrgency | null {
  if (!signs.length) return null;
  // Urgent ranks above Immediate, regardless of the order the signs were found.
  return signs.some(sign => urgencyOf(sign) === 'urgent') ? 'urgent' : 'immediate';
}

export function nameToken(sign: DangerSignFinding): string {
  return riskAssessmentToken(sign.name, sign.severity);
}
